import React from 'react'
import { Property } from '../../../../types/Property/Property'
import DetailsParagraphIcon from '../DetailsParagraphIcon'
import DpeScore from './DpeScore'
import DpeChart from './DpeChart'
import Co2Chart from './Co2Chart'
import { useTranslation } from 'next-i18next'

type DpeWorkSectionProps = {
  className?: string
  property: Property
}

export default function DpeWorkSection({
  className,
  property,
}: DpeWorkSectionProps) {
  const { t } = useTranslation('originals/property')

  return (
    <div className={className}>
      <div className="pb-3">
        <div className="text-3xl font-bold text-neutralBlack">
          {t('dpeAndWorkSection.title')}
        </div>
        <div className="text-justify text-sm font-thin text-neutralBlack">
          {t('dpeAndWorkSection.text')}
        </div>
      </div>

      <div className="mt-2 border-b-[1px] border-dashed border-neutralGray/50 pb-4">
        {/*
          <div className="my-4 grid grid-cols-2 gap-4 md:grid-cols-4">
            {workDetails.slice(0, 1).map((p) => (
              <div
                key={p.name}
                className="border-1 rounded-2xl border-brandLightBlue bg-brandLightBlue p-4"
              >
                <p.icon className="mb-2 h-8 w-8 text-neutralWhite"/>
                <div className="text-3xl text-neutralWhite">{p.content}</div>
                <div className="font-thin text-neutralWhite">{p.name}</div>
              </div>
            ))}

            {workDetails.slice(1).map((p) => (
              <div
                key={p.name}
                className="border-1 rounded-2xl border-brandLightBlue bg-neutralWhite p-4"
              >
                <p.icon className="mb-2 h-8 w-8 text-brandLightBlue"/>
                <div className="text-3xl text-brandLightBlue">{p.content}</div>
                <div className="font-thin text-neutralBlack">{p.name}</div>
              </div>
            ))}
          </div>
        */}
        <DetailsParagraphIcon
          icon="LightBulbIcon"
          title={t('dpeAndWorkSection.toGoFurther.title')}
          text={t('dpeAndWorkSection.toGoFurther.text')}
        />
      </div>
      <div className="">
        {property.energyConsumption > 0 ? (
          <>
            <div className="my-2 pt-2 font-bold text-neutralBlack">
              {t('dpeAndWorkSection.dpe.title')}
            </div>
            <DpeScore score={property.energyConsumption} />
          </>
        ) : (
          <></>
        )}

        <div className="grid grid-cols-1 pt-6 sm:grid-cols-2 md:grid-cols-3">
          {property.energyConsumption > 0 ? (
            <>
              <div className="w-full">
                <div className="pb-2 text-sm font-bold text-neutralBlack">
                  {t('dpeAndWorkSection.dpe.energyConsumption')}
                </div>
                <DpeChart score={property.energyConsumption} />
              </div>
            </>
          ) : (
            <></>
          )}
          {property.gazEmission > 0 ? (
            <>
              <div className="w-full">
                <div className="pb-2 text-sm font-bold text-neutralBlack">
                  {t('dpeAndWorkSection.dpe.gasEmission')}
                </div>
                <Co2Chart score={property.gazEmission} />
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
